import { render, staticRenderFns } from "./SpineConfig.vue?vue&type=template&id=464e6934&scoped=true"
import script from "./SpineConfig.vue?vue&type=script&lang=js"
export * from "./SpineConfig.vue?vue&type=script&lang=js"
import style0 from "./SpineConfig.vue?vue&type=style&index=0&id=464e6934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464e6934",
  null
  
)

export default component.exports